import React from "react";
import { Box, Grid, Rating, Stack } from "@mui/material";
import LandingHeader from "../../../layout/header";
import Footer from "../../../layout/footer";
import { BlueBox, ReviewBox, SubTitle } from "../style";
import { RootStyle, Text, Title } from "../style";
import { AboutGrid, AboutText, AboutTitle } from "../style";
import AboutImg from "../../../images/landing/apps module.png";
import Icon1 from "../../../images/landing/apps icon 1.png";
import Icon2 from "../../../images/landing/apps icon 2.png";
import PartnerLogo from "../../../images/landing/fedro.png";
import AppStore from "../../../images/landing/app store.png";
import PlayStore from "../../../images/landing/playstore.png";
import AccessNow from "../AccessNow";
import { InnerBlueBox } from "../style";

function MobileAppModule() {
  return (
    <Box sx={{ background: "#fff" }}>
      <LandingHeader />
      <RootStyle sx={{ my: "40px" }}>
        <Stack spacing="64px">
          <BlueBox sx={{ minHeight: "163px" }}>
            <InnerBlueBox sx={{ p: "0 0 0 32px", maxHeight: "163px" }}>
              <Grid container>
                <AboutGrid item md={7} xs={12}>
                  <Stack direction="row" spacing="64px">
                    <Stack>
                      <AboutTitle>Mobile Apps</AboutTitle>
                      <SubTitle sx={{ color: "#fff" }}>IOS & Android</SubTitle>
                    </Stack>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        columnGap: "16px",
                      }}
                    >
                      <img height="40px" src={PlayStore} alt="" />
                      <img height="40px" src={AppStore} alt="" />
                    </Box>
                  </Stack>
                </AboutGrid>
                <Grid item md={5} xs={12} sx={{ order: { xs: 1, md: 2 } }}>
                  <Box>
                    <img
                      style={{ maxHeight: "163px" }}
                      width="100%"
                      src={AboutImg}
                      alt=""
                    />
                  </Box>
                </Grid>
              </Grid>
            </InnerBlueBox>
          </BlueBox>

          <Stack spacing="40px" alignItems="center">
            <AboutTitle sx={{ color: "#60656C", textAlign: "center" }}>
              Experience the power of ManageKaro anywhere, anytime
            </AboutTitle>
            <Text sx={{ textAlign: "center" }}>
              Our platform extends beyond the web, offering native Android and
              iOS applications for complete flexibility and accessibility.
              Whether you're in the office, on the go, or working remotely,
              enjoy seamless access to your critical business data and
              functionality.
            </Text>
          </Stack>

          <Box
            sx={{
              background: "#EFFFED",
              p: "64px 32px ",
              borderRadius: "24px",
            }}
          >
            <Grid container spacing="32px">
              <Grid item md={7} xs={12} order={{ xs: 2, md: 1 }}>
                <AboutText>Our platform offers:</AboutText>
                <ul>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Seamless Access Across Devices:</b>Stay productive on
                      the go or in the office with seamless access to your data
                      and tools across all your devices.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Real-Time Insights: </b> Access real-time data and
                      reports regardless of your location. Get instant updates
                      on sales, inventory, finances, and more, enabling you to
                      make informed decisions on the fly.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Unified Interface:</b> Enjoy a consistent user
                      experience across all devices. Our intuitive interface
                      adapts seamlessly to different screen sizes and touch
                      interactions, ensuring a familiar and comfortable
                      workflow.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Enhanced Collaboration:</b>Share information and
                      collaborate with team members seamlessly, regardless of
                      their location or device. Real-time updates and
                      communication tools foster efficient teamwork and project
                      management.
                    </AboutText>
                  </li>
                </ul>
              </Grid>
              <Grid
                item
                md={5}
                xs={12}
                order={{
                  xs: 1,
                  md: 2,
                  background: "#DBF3D7",
                  p: 2,
                  borderRadius: "24px",
                }}
              >
                <img width="100%" src={Icon1} alt="" />
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              background: "#EFFFED",
              p: "64px 32px ",
              borderRadius: "24px",
            }}
          >
            <Grid container spacing="32px">
              <Grid
                item
                md={5}
                xs={12}
                sx={{ background: "#DBF3D7", p: 2, borderRadius: "24px" }}
              >
                <img width="100%" src={Icon2} alt="" />
              </Grid>
              <Grid item md={7} xs={12}>
                <AboutText>Benefits:</AboutText>
                <ul>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Boost productivity:</b>Work from anywhere, anytime, and
                      never miss a beat.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Improve decision-making:</b> Access real-time data and
                      insights at your fingertips.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Streamline workflow: </b>Work across devices without
                      any disruptions or data loss.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Enhance collaboration:</b>Foster effective teamwork and
                      communication regardless of location.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Gain competitive advantage:</b> Respond to changes
                      quickly and adapt to market needs with agility.
                    </AboutText>
                  </li>
                </ul>
                <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                  Experience the unparalleled flexibility and power of a truly
                  unified business management platform.
                </AboutText>
              </Grid>
            </Grid>
          </Box>

          <ReviewBox>
            <Grid container spacing="16px">
              <Grid
                item
                md={6}
                xs={12}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Stack>
                  <Text sx={{ color: "#fff" }}>
                    “The automated expiry date tracking feature has eliminated
                    the risk of oversight. ManageKaro ensures that we receive
                    timely alerts and notifications for upcoming expirations,
                    enabling us to take proactive measures such as restocking or
                    proper disposal. This has not only minimized the chances of
                    selling expired products but has also helped us maintain
                    compliance with regulatory standards.The mobile app provided
                    by ManageKaro has been a game-changer for us. Its
                    user-friendly interface make it easy for our team to access
                    and update crucial information on the go. This has proven to
                    be invaluable, especially when dealing with the
                    time-sensitivity of medicine expiry dates.”
                  </Text>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: { xs: "center", md: "flex-start" },
                    }}
                  >
                    <Rating name="simple-controlled" value={5} />
                  </Box>
                </Stack>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyItems: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={PartnerLogo} alt="" />
                  <Box>
                    <Title sx={{ color: "#fff" }}>Fedro Pharma</Title>
                    <Title sx={{ color: "#fff", fontSize: "24px" }}>
                      Mr Nauman
                    </Title>
                    <Text sx={{ color: "#fff", fontStyle: "italic" }}>
                      Thokar Niaz Baig, Multan Road, Lahore
                    </Text>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </ReviewBox>

          <AccessNow />
        </Stack>
      </RootStyle>
      <Footer />
    </Box>
  );
}

export default MobileAppModule;
